export default [
  {
    symbol_coin: 'DAI',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '1.0102965638333334',
    geometric_mean: '1.010296554009926',
    harmonic_mean: '1.0102965441871645',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'VET',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.011992470066666669',
    geometric_mean: '0.01199246999068714',
    harmonic_mean: '0.011992469914703574',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'BSV',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '160.42850542193332',
    geometric_mean: '160.42850299701973',
    harmonic_mean: '160.428500572305',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'ATOM*',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '4.9100367146',
    geometric_mean: '4.910036684081559',
    harmonic_mean: '4.910036653564724',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'YFI',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '21268.426755149267',
    geometric_mean: '21268.42636857424',
    harmonic_mean: '21268.425981964494',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'OMG',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '3.7831828578333333',
    geometric_mean: '3.783182854904039',
    harmonic_mean: '3.7831828519746904',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'HT',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '4.708737737',
    geometric_mean: '4.708737582970287',
    harmonic_mean: '4.708737428959151',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'LTC',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '44.92997621360001',
    geometric_mean: '44.92997620954208',
    harmonic_mean: '44.92997620548416',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'HEX',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.0036574099',
    geometric_mean: '0.0036574098845652218',
    harmonic_mean: '0.0036574098691311095',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'SNX',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '4.3419228745666665',
    geometric_mean: '4.34192286885969',
    harmonic_mean: '4.341922863152852',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'EOS',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '2.4736491884333334',
    geometric_mean: '2.4736491884215503',
    harmonic_mean: '2.4736491884097678',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'USDC',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '1.0006060849333334',
    geometric_mean: '1.0006060765357794',
    harmonic_mean: '1.0006060681387383',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'CRO',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.14736080823333333',
    geometric_mean: '0.1473608080777774',
    harmonic_mean: '0.1473608079222248',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'THETA',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.6805901421999999',
    geometric_mean: '0.6805901102277765',
    harmonic_mean: '0.6805900782601738',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'LEO*',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '1.2641257382666666',
    geometric_mean: '1.2641257285898946',
    harmonic_mean: '1.264125718913687',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'DOT***',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '4.078524524833333',
    geometric_mean: '4.0785245188259385',
    harmonic_mean: '4.0785245128186975',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'XEM',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.11482565403333334',
    geometric_mean: '0.11482564453560852',
    harmonic_mean: '0.11482563503970526',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'WBTC***',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '10601.442308901767',
    geometric_mean: '10601.442297526963',
    harmonic_mean: '10601.442286152416',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'BTC',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '10544.732067160434',
    geometric_mean: '10544.732061286835',
    harmonic_mean: '10544.73205541334',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'LEND',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.5334810717333333',
    geometric_mean: '0.5334810515989982',
    harmonic_mean: '0.5334810314620558',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'COMP**',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '122.12604290830001',
    geometric_mean: '122.1260422049745',
    harmonic_mean: '122.12604150168463',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'CDAI',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.0210690241',
    geometric_mean: '0.021069024088271673',
    harmonic_mean: '0.02106902407654352',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'XLM',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.0711462995',
    geometric_mean: '0.07114629938119378',
    harmonic_mean: '0.0711462992623843',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'ETH',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '344.9357134629667',
    geometric_mean: '344.93571326938593',
    harmonic_mean: '344.93571307580237',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'UMA',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '7.593491407166667',
    geometric_mean: '7.593491401582367',
    harmonic_mean: '7.59349139599817',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'ADA',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.09356401433333333',
    geometric_mean: '0.09356400882282465',
    harmonic_mean: '0.0935640033114246',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'BCH',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '219.4402871085333',
    geometric_mean: '219.44028678014294',
    harmonic_mean: '219.44028645176112',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'LINK',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '9.234802358066666',
    geometric_mean: '9.234802258829609',
    harmonic_mean: '9.234802159585694',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'DGB',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.0258776679',
    geometric_mean: '0.025877667722873216',
    harmonic_mean: '0.025877667545756194',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'OKB',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '6.1914578315',
    geometric_mean: '6.191457804772819',
    harmonic_mean: '6.19145777804681',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'XMR',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '97.77565095203333',
    geometric_mean: '97.77565042242136',
    harmonic_mean: '97.77564989278349',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'DASH',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '65.57030690033334',
    geometric_mean: '65.57030689314776',
    harmonic_mean: '65.57030688596228',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'ZEC',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '62.38386554726667',
    geometric_mean: '62.38386554702189',
    harmonic_mean: '62.38386554677715',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'TUSD',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '1.0003954045999999',
    geometric_mean: '1.0003954023445802',
    harmonic_mean: '1.000395400089232',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'FTT**',
    end_time: '2020-10-02T15:34:00.000Z',
    arithmetic_mean: '3.5260994519',
    geometric_mean: '3.5260994519',
    harmonic_mean: '3.5260994519',
    start_time: '2020-10-02T15:29:00.000Z',
  },
  {
    symbol_coin: 'BNB',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '27.10030257236666',
    geometric_mean: '27.100301939743634',
    harmonic_mean: '27.100301307056185',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'XTZ',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '2.085201478266667',
    geometric_mean: '2.085201449154061',
    harmonic_mean: '2.0852014200437488',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'XRP',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.2328229191',
    geometric_mean: '0.23282291854616813',
    harmonic_mean: '0.23282291799231816',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'CEL',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '1.0359278058333334',
    geometric_mean: '1.035927804758018',
    harmonic_mean: '1.0359278036827257',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'BUSD',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '1.0009689818',
    geometric_mean: '1.000968976253284',
    harmonic_mean: '1.0009689707068437',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'ETC',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '5.183122634266667',
    geometric_mean: '5.183122607855053',
    harmonic_mean: '5.183122581442185',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'WETH',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '345.2377222083333',
    geometric_mean: '345.2377221649361',
    harmonic_mean: '345.23772212153864',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'UNI***',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '3.9431022246000005',
    geometric_mean: '3.943102219774821',
    harmonic_mean: '3.943102214949756',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'NEO',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '18.1980225332',
    geometric_mean: '18.198022314047776',
    harmonic_mean: '18.19802209487953',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'MIOTA',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.26155127063333333',
    geometric_mean: '0.26155126955695823',
    harmonic_mean: '0.2615512684806292',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'USDT',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '1.0012284087333334',
    geometric_mean: '1.0012283993120308',
    harmonic_mean: '1.0012283898913374',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'TRX',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.0250149308',
    geometric_mean: '0.025014930753973017',
    harmonic_mean: '0.025014930707944704',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'DOGE',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.0025890492',
    geometric_mean: '0.0025890491833547176',
    harmonic_mean: '0.002589049166710324',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'MKR',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '547.6528766434',
    geometric_mean: '547.6528765246293',
    harmonic_mean: '547.6528764058578',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'ALGO',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.318327789',
    geometric_mean: '0.3183277321652109',
    harmonic_mean: '0.3183276753144184',
    start_time: '2020-10-02T15:32:00.000Z',
  },
  {
    symbol_coin: 'ONT',
    end_time: '2020-10-02T15:37:00.000Z',
    arithmetic_mean: '0.5896392136999999',
    geometric_mean: '0.5896392052476293',
    harmonic_mean: '0.5896391967959331',
    start_time: '2020-10-02T15:32:00.000Z',
  },
];
